<ng-container>
  <select class="form-control input-sm"
    [id]="specName"
    [name]="specName"
    [disabled]="disabled"
    [ngModel]="selectedValue"
    (ngModelChange)="selectedValueChanges($event)">
    <option [ngValue]="null">-</option>
    @for (key of keys; track key) {
      <option [ngValue]="key">{{key}}</option>
    }
  </select>
</ng-container>
